import { debounce } from "lodash-es";
import { baseFetch } from "../api/baseFetch";
import { getUrlWithSearchParams } from "../common/helpres/link";
import { isDevHost, membersLink } from "../credentials/consts/links";
export var ApiCustomerMe;
(function (ApiCustomerMe) {
    const domain = isDevHost() ? "" : membersLink;
    const customersLink = domain + "/api/v1/customers/me";
    const _get = async () => {
        return baseFetch({
            url: getUrlWithSearchParams(customersLink, {}),
            withCredentials: true,
        });
    };
    ApiCustomerMe.get = debounce(_get, 3600, { leading: true, trailing: false });
})(ApiCustomerMe || (ApiCustomerMe = {}));
